<template>
    <div class="pedido-listado">
        <section class="pedido-steps" v-if="!mostrar_detalle">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="return d-block d-sm-none">
                            <router-link :to="route">
                                <img src="assets/img/backspace.svg" class="mb-5">
                            </router-link>
                        </div>
                        <div class="section-title">
                            <h5 class="pull-left">{{ $t("title") }}</h5>
                            <router-link :to="route">
                                <img class="d-none d-sm-block" src="assets/img/backspace.svg">
                            </router-link>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="search-row">
                            <div class="pull-left order-xs-2">
                                <label class="pr-1">{{ $t("status") }}</label>
                                <select @change="filtrarPedidos('status',$event)" id="pedidosFilter">
                                    <option selected value="">{{ $t("all") }}</option>
                                    <option value="APPROVED">{{ $t("approved") }}</option>
                                    <option value="PROCESSING">{{ $t("processing") }}</option>
                                    <option value="PENDING">{{ $t("pending") }}</option>
                                    <option value="PROCESSED">{{ $t("processed") }}</option>
                                    <option value="CANCELED">{{ $t("canceled") }}</option>
                                    <option value="INVOICED">{{ $t("invoiced") }}</option>
                                </select>	
                            </div>
                            <div class="pull-right order-xs-1">
                                <div class="position-relative">
                                    <label class="mr-4 ml-4" data-toggle="modal" data-target="#glosarioModal"><img src="assets/img/help.svg"></label>
                                </div>
                            </div>
                        </div>
                    </div>	
                </div>
                <div class="row" id="mostrarTablas">
                    <div class="col-md-12">
                        <div class="confirmado mt-2">
                            <!--Para desktop-->
                            <table class="bg-white d-none d-sm-table" id="pedidosTable">
                                <thead>
                                    <tr>
                                        <th>{{ $t("date") }}</th>
                                        <th class="text-center">{{ $t("order_number") }}</th>
                                        <th class="text-center">{{ $t("purchase_order") }}</th>
                                        <th class="text-center">{{ $t("sap_number") }}</th>
                                        <th class="text-center">{{ $t("ship_to") }}</th>
                                        <th class="text-center">{{ $t("selected_delivery_date") }}</th>
                                        <th class="text-center">{{ $t("status") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="b-top" v-for="(order,index) in this.orders" :key="index">
                                        <td>{{order.date_creation}}</td>
                                        <td class="text-center">{{order.order_number}}</td>
                                        <td class="text-center">{{order.purchase_order}}</td>
                                        <td class="text-center">{{order.order_number_sap || '-'}}</td>
                                        <td class="text-center">{{order.delivery_name}}</td>
                                        <td class="text-center">{{order.delivery_date}}</td>
                                        <td class="text-center">
                                            <div class="inline-flex align-center label-content justify-center">
                                                <a href="javascript:void(0)" :class="'label-' + order.state">{{order.state_name}}</a>
                                                <img class="mr-2 ml-2 pointer" @click="verPedido(order.id)" src="assets/img/more.svg">
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <!--Para mobile hay que hacer una tabla por pedido-->
                            <table class="bg-white d-block d-sm-none pedidosTableMobile b-top" v-for="(order,index) in this.orders" :key="index">
                               
                                <tr>
                                    <th>{{ $t("date") }}</th>
                                    <td>{{order.date_creation}}</td>
                                </tr>
                                <tr>
                                    <th class="text-center">{{ $t("order_number") }}</th>
                                    <td class="text-center">{{order.order_number}}</td>
                                </tr>
                                <tr>
                                    <th class="text-center">{{ $t("purchase_order") }}</th>
                                    <td class="text-center">{{order.purchase_order}}</td>
                                </tr>
                                <tr>
                                    <th class="text-center">{{ $t("sap_number") }}</th>
                                    <td class="text-center">{{order.order_number_sap || '-'}}</td>
                                </tr>
                                <tr>
                                    <th class="text-center">{{ $t("ship_to") }}</th>
                                    <td class="text-center">{{order.delivery_name}}</td>
                                </tr>
                                <tr>
                                    <th class="text-center">{{ $t("selected_delivery_date") }}</th>
                                    <td class="text-center">{{order.delivery_date}}</td>
                                </tr>
                                <tr>
                                    <th class="text-center">{{ $t("status") }}</th>
                                    <td class="text-center">
                                        <div class="inline-flex align-center label-content justify-center">
                                            <a href="javascript:void(0)" :class="'label-' + order.state">{{order.state_name}}</a>
                                            <img class="mr-2 ml-2 pointer" @click="verPedido(order.id)" src="assets/img/more.svg">
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="loading"></div>
                <div class="row">
                    <div class="col-md-12 text-center mb-5"> 
                        <Vue3BsPaginate
                            :total="this.total_paginas"
                            v-model="this.filtro_page"
                            :perPage="10"
                            :onChange="filtrarPedidos"
                            alignment="center"
                        />
                    </div>
                </div>
            </div>
        </section>
        <GlosarioModal></GlosarioModal>
        <PedidoDetalle v-if="mostrar_detalle" :order_id="this.order_id"  @ocultarDetalleChild="ocultarDetalle"></PedidoDetalle>
        <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert" />
    </div>
</template>

<script>
    import GlosarioModal from '../layouts/GlosarioModal.vue'
    import PedidoDetalle from './PedidoDetalle.vue'
	import { route } from "../../enviroment.js" 
    // import axios from 'axios'
    import $ from 'jquery'   
    import { Vue3BsPaginate } from 'vue3-bootstrap-paginate';
    import axiosInstance from '../../main';
    import authMixin from '@/mixins/authMixin';

    export default {
        name: 'PedidosListado',
        i18n: {
            messages: {
                en: {
                    title: "List of orders sent to McCain for processing.",
                    status: "Status",
                    all: "All",
                    approved: "Approved",
                    processing: "Processing",
                    pending: "Pending",
                    processed: "Approval Pending",
                    canceled: "Canceled",
                    invoiced: "Invoiced",
                    date: "Date",
                    order_number: "Order Number",
                    purchase_order: "Purchase Order",
                    sap_number: "SAP Number",
                    ship_to: "Ship To",
                    selected_delivery_date: "Selected Delivery Date",
                },
                es: {
                    title: "Listado de los pedidos que fueron enviados a McCain para su procesamiento.",
                    status: "Estado",
                    all: "Todos",
                    approved: "Aprobado",
                    processing: "Enviando",
                    pending: "Pendiente",
                    processed: "Aprobación Pendiente",
                    canceled: "Cancelada",
                    invoiced: "Facturado",
                    date: "Fecha",
                    order_number: "Número Pedido",
                    purchase_order: "Purchase order",
                    sap_number: "Número SAP",
                    ship_to: "Lugar de entrega",
                    selected_delivery_date: "Fecha requerida de entrega",
                }
            }
        },
        components: {
            GlosarioModal,
            PedidoDetalle,
            Vue3BsPaginate
        },
        data: function () {
            return {
                orders: [],                
                orders_data: [],                
                key: '',
                mostrar_detalle: false,
                route : route,
                order_id: '',
                filtro_estado: '',
                filtro_page: 1,
                total_paginas: '',
            }
        },
        mixins: [authMixin],
        async created(){
            await this.validateUserAndSoldTo();
            this.getOrders()
        },        
        methods:{
            showAlert(type, title, message) {
                this.$refs.alert.showAlert(
                    type, // There are 4 types of alert: success, info, warning, error
                    message, // Message of the alert
                    title, // Header of the alert
                    { 
                        iconSize: 35, // Size of the icon (px)
                        iconType: 'solid', // Icon styles: now only 2 styles 'solid' and 'regular'
                        position: 'top right' // Position of the alert 'top right', 'top left', 'bottom left', 'bottom right' 
                    } 
                )
            },
            filtrarPedidos(filter,event){
                this.mostrarCarga()
                if (filter == 'status'){
                    this.filtro_estado = event.target.value
                }
                this.getOrders()
            },
            filtrarPedidosByOrderNumber(filter,event){
                this.mostrarCarga()
                if (filter == 'status'){
                    this.filtro_estado = event.target.value
                }
                this.getOrders()
            },
            getCookie(cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for(var i=0; i<ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0)==' ') c = c.substring(1);
                    if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
                }
                return "";
            },
            ocultarDetalle(variable){
                this.mostrar_detalle = variable
                this.getOrders(variable)
            },
            verPedido(id){
                this.mostrar_detalle = true
                this.order_id = id
            },
            mostrarCarga(){
                $('.loading').removeClass('d-none');
                $('#mostrarTablas').addClass('d-none');
            },
            ocultarCarga(){
                $('.loading').addClass('d-none');
                $('#mostrarTablas').removeClass('d-none');
            },
            getOrders(){
                axiosInstance.post(this.$woe_api_uri + '/order', 
                    {
                        'page': this.filtro_page,
                        'status': this.filtro_estado                    
                    }
                ).then((response) => {
                    this.ocultarCarga()
                    this.orders = response.data.data.orders
                    this.total_paginas = response.data.data.paginator.pages
                    this.orders_data = response.data.data
                })
                .catch((error) => {
                    if (error.code == "ERR_BAD_REQUEST" ){
                        this.showAlert('warning',`${this.$t("caution")}!`, error.response.data.error.message);
                        setTimeout(() => {
                        this.$router.push('/');
                        }, 5000);
                    } else {
                        this.showAlert('warning',`${this.$t("caution")}!`, error.response.data.error.message);
                    }
                });
            }
        }
    }
</script>
<style>
    .pagination li {
        margin: 0 !important;
    }
</style>